import  Tooltip  from '../Tooltip';
import { Badge } from 'rsuite';

const SCBadge = ({tooltip, ...props}) => {
    return tooltip && <Tooltip text={tooltip}><Badge {...props} /></Tooltip> || <Badge {...props} /> || null
}

export default SCBadge;